import { PropTypes } from "prop-types"

import Input from "../Input"

export const InputEmail = props => <Input className="oj-input-email" type="email" {...props} />

InputEmail.propTypes = {
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  placeholder: PropTypes.string.isRequired
}

export default InputEmail
